import React, { useContext } from "react";
import { Offcanvas } from "react-bootstrap";
import PsContext from "../../context";

const ReportDetails = (props) => {
  const context = useContext(PsContext);
  const data = props.dataSource;

  let hourCount =
    props.dataSource?.[0].att_hour_per_day ||
    context.settingValue("hour_for_attendance_per_day");

  const title = () => {
    if (data && data.length > 0) {
      let item = data[0];
      return `${item.degree_name} ${
        item.course_short_name ? item.course_short_name : ""
      } (${item.dept_type == "aided" ? "R" : "SF"})`;
    }
  };

  const checkHourExist = (hour) => {
    let m = data && data.find((item) => item.hour_value == hour);
    return m && m.hour_value ? true : false;
  };

  const getAttTime = (hour) => {
    let m = data && data.find((item) => item.hour_value == hour);
    return (m && m.attendance_time) || "";
  };

  const getSubjectName = (hour) => {
    let m = data && data.find((item) => item.hour_value == hour);
    if (m && m.subject_name) {
      return (
        <div>
          <b>{m.subject_code}</b> - {m.subject_name}
          <br />
          <span className=" fw-bold bg-color">
            {m.emp_name} {m.emp_initial}
          </span>
        </div>
      );
    }
  };

  const getData = () => {
    let rv = [];
    for (let i = 1; i <= hourCount; i++) {
      rv.push(
        <li className="border-bottom p-3 bg-white" style={{ fontSize: "16px" }}>
          <div>
            <b>Hour-{i} </b>- {getAttTime(i)}
            <span className="text-success float-end">
              {checkHourExist(i) && "Marked"}
            </span>
          </div>
          {getSubjectName(i)}
        </li>
      );
    }
    return rv;
  };

  return (
    <div className="container-sm py-md-3">
      <ul className="m-0 p-0">{getData()}</ul>
      <div className="py-3"></div>
    </div>
  );
};
export default ReportDetails;
